// /src/components/AdminLockEnforcer.jsx

import { useEffect, useRef } from "react";
import axios from "axios";
import { useAuth } from "../authContext";
import { statusSocket, securitySocket } from "../../utils/Socket";

export default function AdminLockEnforcer() {
  const { isLoggedIn } = useAuth();
  const checkInFlightRef = useRef(false);

  useEffect(() => {
    if (!isLoggedIn) return undefined;

    const verifyLockAccess = async () => {
      if (checkInFlightRef.current) return;
      checkInFlightRef.current = true;

      try {
        const res = await axios.get("/api/auth/check-lock-access", {
          withCredentials: true,
        });

        if (res.data?.allowed === false) {
          window.dispatchEvent(
            new CustomEvent("auth:force-logout", {
              detail: { reason: "admin-lock" },
            })
          );
        }
      } catch (err) {
        // Only treat explicit admin_lock 403 as a lock kick.
        // Do not treat 401 (expired token / backend restart) as admin-lock —
        // that used to call logout-on-error and revoke the shared session.
        if (
          err?.response?.status === 403 &&
          err?.response?.data?.code === "admin_lock"
        ) {
          window.dispatchEvent(
            new CustomEvent("auth:force-logout", {
              detail: { reason: "admin-lock" },
            })
          );
        }
      } finally {
        checkInFlightRef.current = false;
      }
    };

    statusSocket.on("status:update", verifyLockAccess);
    securitySocket.on("security:update", verifyLockAccess);

    return () => {
      statusSocket.off("status:update", verifyLockAccess);
      securitySocket.off("security:update", verifyLockAccess);
    };
  }, [isLoggedIn]);

  return null;
}
